export default "__VITE_ASSET__DAn$PcBF__"